module.exports = __webpack_public_path__ + "static/media/faq_social_20250610.851ceb02.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/faq_social_20250610.pdf
// module id = 2305
// module chunks = 0